module.exports = __webpack_public_path__ + "img/shop_supply.11d16419.svg";